import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import PracticeBlockData from '../../../Models/Content/PracticeBlockData';
import {PracticeBlockMain} from './PracticeBlockMain';

export default class PracticeBlock extends EpiComponent<PracticeBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <PracticeBlockMain context={this.getContext()} contentData={this.props.data} />;
  }
}
